import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const DEFAULT_MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const DEFAULT_FORMATS = ['bold', 'italic', 'underline', 'list', 'link'];

/**
 * RichTextEditor — wrapper Quill com toolbar mínima e API simples.
 *
 * Props:
 *   value: string (HTML)
 *   onChange: (html) => void
 *   placeholder?: string
 *   minHeight?: string
 *   testid?: string
 */
export default function RichTextEditor({
  value,
  onChange,
  placeholder = 'Escreva aqui...',
  minHeight = '150px',
  testid,
}) {
  return (
    <div data-testid={testid || 'rich-text-editor'} className="rich-text-editor-wrapper">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        modules={DEFAULT_MODULES}
        formats={DEFAULT_FORMATS}
        style={{ minHeight }}
      />
      <style>{`
        .rich-text-editor-wrapper .ql-container { min-height: ${minHeight}; }
        .rich-text-editor-wrapper .ql-editor { min-height: ${minHeight}; }
      `}</style>
    </div>
  );
}
